import * as Redux from 'redux';
import { QueryCondition } from '../misc/api/apiTypes';
import { MainState } from '../Core/reducers';
import { WebPortalLegacyClientInternal } from '../misc/api/WebPortalTokenClient';

export enum BloodGlucoseActionType {
    ClearBloodGlucoseSessions = 'ClearBloodGlucoseSessions',
    LoadBloodGlucoseSessions = 'LoadBloodGlucoseSessions',
    SortBloodGlucoseSessions = 'SortBloodGlucoseSessions',
    FilterBloodGlucoseSessions = 'FilterBloodGlucoseSessions',
    ClearAllSessionFilters = 'ClearAllSessionFilters',
    ClearAllTestFilters = 'ClearAllTestFilters',
    PageBloodGlucoseSessions = 'PageBloodGlucoseSessions',
    LoadSessionFilter = 'LoadSessionFilter',
}

declare const rootUrl: string;

export class FetchBloodGlucoseSessionsAction {
    static create(legacyClient: WebPortalLegacyClientInternal) {
        return (dispatch: (action: Redux.Action) => void, getState: () => MainState) => {
            const state = getState();

            dispatch(ClearBloodGlucoseSessionsAction.create());

            legacyClient.getBloodGlucoseSessions({ ...state.bloodGlucoseList.sessionQuery, Data: null })
            .then(json => {
                dispatch(LoadBloodGlucoseSessionsAction.create(json));
            });
        };
    }
}

export class ClearBloodGlucoseSessionsAction implements Redux.Action {
    type: BloodGlucoseActionType.ClearBloodGlucoseSessions;

    static create(): ClearBloodGlucoseSessionsAction {
        return {
            type: BloodGlucoseActionType.ClearBloodGlucoseSessions,
        };
    }
}

export class LoadBloodGlucoseSessionsAction implements Redux.Action {
    type: BloodGlucoseActionType.LoadBloodGlucoseSessions;
    data;

    static create(response): LoadBloodGlucoseSessionsAction {
        return {
            type: BloodGlucoseActionType.LoadBloodGlucoseSessions,
            data: response,
        };
    }
}

export class SortBloodGlucoseSessionsAction implements Redux.Action {
    type: BloodGlucoseActionType.SortBloodGlucoseSessions;
    member: string;

    static create(member: string): SortBloodGlucoseSessionsAction {
        return {
            type: BloodGlucoseActionType.SortBloodGlucoseSessions,
            member: member,
        };
    }
}

export class FilterBloodGlucoseSessionsAction implements Redux.Action {
    type: BloodGlucoseActionType.FilterBloodGlucoseSessions;
    member: string;
    condition: QueryCondition;
    value: any;

    static create(member: string, condition: QueryCondition, value: any): FilterBloodGlucoseSessionsAction {
        return {
            type: BloodGlucoseActionType.FilterBloodGlucoseSessions,
            member: member,
            condition: condition,
            value: value,
        };
    }
}

export class ClearAllSessionFiltersAction implements Redux.Action {
    type: BloodGlucoseActionType.ClearAllSessionFilters;

    static create(): ClearAllSessionFiltersAction {
        return {
            type: BloodGlucoseActionType.ClearAllSessionFilters,
        }
    }
}

export class PageBloodGlucoseSessionsAction implements Redux.Action {
    type: BloodGlucoseActionType.PageBloodGlucoseSessions;
    page: number;

    static create(page: number): PageBloodGlucoseSessionsAction {
        return {
            type: BloodGlucoseActionType.PageBloodGlucoseSessions,
            page: page,
        };
    }
}

export class FetchSessionFilterAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal) {
        return (dispatch: (action: Redux.Action) => void, getState: () => MainState) => {
            const state = getState();

            legacyClient.getBloodGlucoseSessions({ ...state.bloodGlucoseList.sessionFilterQuery, Data: null })
                .then(json => {
                    dispatch(LoadSessionFilterAction.create(json));
                });
        };
    }
}

export class LoadSessionFilterAction implements Redux.Action {
    type: BloodGlucoseActionType.LoadSessionFilter;
    query: any;

    static create(response: any): LoadSessionFilterAction {
        return {
            type: BloodGlucoseActionType.LoadSessionFilter,
            query: response,
        };
    }
}


export type BloodGlucoseAction = ClearBloodGlucoseSessionsAction
    | LoadBloodGlucoseSessionsAction
    | SortBloodGlucoseSessionsAction
    | FilterBloodGlucoseSessionsAction
    | ClearAllSessionFiltersAction
    | PageBloodGlucoseSessionsAction
    | LoadSessionFilterAction;
